import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Home, PrivacyPolicy  } from '../pages';

const MainRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/privacypolicy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
};

export default MainRoutes;